/* eslint-disable prettier/prettier */
export default {
  duringVisit: {
    updateApp: "You'll need to update your app to access your video visit",
    subText: {
      asapBookingActiveMembership: 'A provider will be ready to see you soon.',
      asapBookingNonActiveMembership: `We\'ve sent your information to {{ displayNamePrimary }}. A provider will be ready to see you soon.`,
      nonAsapBookingActiveMembership: 'Please join the video visit 15 minutes before your visit ',
      nonAsapBookingNonActiveMembership: `We\'ve sent your information to {{ displayNamePrimary }}. Please join the video visit 15 minutes before your visit `,
    },
    joinCall: 'Join the Call',
    thankYou: 'Thank You',
  },
  waitingRoom: {
    greeting: 'Hi {{ FIRST_NAME }},',
    pleaseWait: 'Please wait here until a provider joins your call.',
    providerWillJoinSoon:
      'If you are not connected with a provider within {{ PREMIUM_TELEMED_SLA_MINUTES }} minutes, please contact:',
    exitConfirmation: {
      areYouSure: 'Are you sure you want to leave the waiting room?',
      warning: 'By leaving the waiting room, you might miss connecting to your provider.',
      endCall: 'End the call',
      goBack: 'Return to the waiting room',
    },
    timeWaiting: 'Time waiting: {{ TIME_LABEL }}',
  },
  postVisit: {
    title: 'Video visit complete',
    audioPrompt: 'How was your audio quality?',
    videoPrompt: 'How was your video quality?',
    combinedQualityPrompt: 'How was your video and audio quality?',
    selectStarRating: '(please select a star rating)',
    providerPrompt: 'How was your experience with the provider?',
    providerCommentPlaceholder: "Were there any problems with your visit you'd like to mention?",
    commentPlaceholder: 'Anything else you’d like to mention?',
    backPrompt: 'Return To Call',
    primaryAction: 'Submit',
    contactUs: 'Having issues? Need anything? <br> Email us at: <1>{{email}}</1>',
    feedback: 'We appreciate your feedback.',
    dismiss: 'Done',
  },
};
